import React from "react";
import "./Hamburger.css";

const Hamburger = (props) => {
  return (
    <div className="Hamburger" onClick={props.onClick}>
      <i className="fa fa-bars" aria-hidden="true"></i>
    </div>
  );
};

export default Hamburger;
